export const siteMeta = {
  brand: "瓜哥吃瓜",
  slogan: "看热闹，更看门道",
  tagline: "神点评 · 犀利吐槽 · 爆笑锐评",
  intro:
    "瓜哥吃瓜专注娱乐热点的锐评与吐槽，把每一场热闹拆开揉碎，用一针见血的神点评讲清来龙去脉。名场面、金句弹幕高能频出，让你吃瓜不只图一乐，还能看懂背后的门道。",
  email: "guage@chigua-daily.com",
  since: "2021 年开张",
  heroImage:
    "https://readdy.ai/api/search-image?query=stylized%20abstract%20stage%20spotlight%20with%20warm%20coral%20red%20and%20amber%20glow%2C%20confetti%20and%20floating%20glossy%20speech%20bubbles%2C%20theatrical%20dramatic%20mood%2C%20cinematic%20gradient%20background%2C%20high%20contrast%20dark%20tones%20with%20vivid%20highlights%2C%20editorial%20poster%20aesthetic&width=1600&height=900&seq=guageng-hero-01&orientation=landscape",
};

export const navLinks = [
  { id: "about", label: "瓜哥宗旨" },
  { id: "roast", label: "热门神点评" },
  { id: "moments", label: "名场面" },
  { id: "quotes", label: "金句弹幕" },
  { id: "topics", label: "主题分类" },
  { id: "feature", label: "精选长评" },
  { id: "faq", label: "常见问题" },
  { id: "contact", label: "订阅吃瓜" },
];

export const heroStats = [
  { value: "1286", label: "已拆解名场面" },
  { value: "340万", label: "弹幕金句收录" },
  { value: "97%", label: "瓜友表示解气" },
];

export const features = [
  {
    icon: "ri-mic-2-line",
    title: "神点评",
    desc: "热点一出，瓜哥先捋时间线再下判断。不跟风、不站队，一句话点在事件的关键节点上。",
    tone: "primary",
  },
  {
    icon: "ri-sword-line",
    title: "犀利吐槽",
    desc: "该说就说，槽点不留情面。吐槽归吐槽，角度讲道理，让人笑完还能点头。",
    tone: "accent",
  },
  {
    icon: "ri-emotion-laugh-line",
    title: "爆笑锐评",
    desc: "把复杂的舆论场翻译成人话，用接地气的比喻和梗，把一场混战讲成爆笑段子。",
    tone: "secondary",
  },
  {
    icon: "ri-chat-quote-line",
    title: "金句弹幕",
    desc: "从百万条弹幕里捞出会心一击的那几句，名场面配金句，反复回看不腻。",
    tone: "primary",
  },
];

export const roastPosts = [
  {
    id: "r1",
    title: "综艺临时加规则那期，瓜哥一句话点破剧本感",
    summary:
      "前半场还在讲情怀，后半场突然改赛制，剪辑的节奏比选手的心跳还快。瓜哥把三个时间点摊开对比，剧本痕迹一目了然。",
    category: "综艺观察",
    author: "瓜哥",
    date: "2026-08-28",
    heat: "48.2万",
    read: "6 分钟",
    tags: ["剧本感", "赛制翻车"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20television%20studio%20stage%20with%20warm%20amber%20and%20coral%20stage%20lights%2C%20empty%20judges%20desk%20and%20microphone%2C%20dramatic%20spotlight%2C%20moody%20editorial%20photography%2C%20clean%20composition%2C%20dark%20background%20with%20vivid%20highlights&width=800&height=600&seq=guageng-roast-01&orientation=landscape",
  },
  {
    id: "r2",
    title: "顶流塌房连环瓜：从手滑到实锤只用了三小时",
    summary:
      "凌晨一条动态，早上一个声明，中午就上了实锤合集。瓜哥按分钟还原了这场三小时速通，顺便聊聊声明里最不敢提的那句话。",
    category: "热点复盘",
    author: "瓜哥",
    date: "2026-08-25",
    heat: "63.7万",
    read: "8 分钟",
    tags: ["时间线还原", "声明拆解"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20falling%20domino%20tiles%20in%20warm%20coral%20and%20amber%20lighting%2C%20dark%20studio%20background%2C%20metaphor%20of%20chain%20reaction%2C%20editorial%20still%20life%20photography%2C%20high%20contrast%2C%20clean%20composition&width=800&height=600&seq=guageng-roast-02&orientation=landscape",
  },
  {
    id: "r3",
    title: "红毯生图大战：精修和现场差的不是一点半点",
    summary:
      "同一条裙子，出图三版。瓜哥把工作室精修、媒体直出和路人随手拍排在一起，讲清楚修图到底在遮掩什么。",
    category: "星光造型",
    author: "瓜哥",
    date: "2026-08-21",
    heat: "35.9万",
    read: "5 分钟",
    tags: ["生图对比", "造型点评"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20glamorous%20red%20carpet%20with%20warm%20gold%20camera%20flashes%2C%20elegant%20fabric%20and%20spotlight%20bokeh%2C%20no%20people%2C%20moody%20editorial%20fashion%20background%2C%20rich%20coral%20and%20amber%20tones%2C%20cinematic%20composition&width=800&height=600&seq=guageng-roast-03&orientation=landscape",
  },
  {
    id: "r4",
    title: "选秀决赛舞台翻车合集，弹幕都在替导演尴尬",
    summary:
      "耳返失灵、走位撞人、导播切错机位，一场决赛集齐了所有名场面。瓜哥逐帧标注，告诉你哪几处根本不是事故，是准备不足。",
    category: "名场面",
    author: "瓜哥",
    date: "2026-08-18",
    heat: "52.4万",
    read: "7 分钟",
    tags: ["舞台事故", "逐帧拆解"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20concert%20stage%20with%20warm%20amber%20beam%20lights%20and%20haze%2C%20empty%20stage%20with%20microphone%20stand%2C%20dramatic%20backlight%2C%20no%20people%2C%20editorial%20concert%20photography%2C%20clean%20dark%20background&width=800&height=600&seq=guageng-roast-04&orientation=landscape",
  },
  {
    id: "r5",
    title: "明星工作室文案翻车，公关稿写成大型自曝",
    summary:
      "一份想澄清的声明，硬生生把三个没被问到的问题全答了。瓜哥逐句划线，教你怎么从公关稿的字缝里读重点。",
    category: "热点复盘",
    author: "瓜哥",
    date: "2026-08-14",
    heat: "41.1万",
    read: "6 分钟",
    tags: ["公关稿", "逐句划线"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20stack%20of%20paper%20documents%20and%20red%20marker%20on%20warm%20wooden%20desk%2C%20soft%20amber%20lighting%2C%20editorial%20desk%20still%20life%2C%20shallow%20depth%20of%20field%2C%20clean%20warm%20background&width=800&height=600&seq=guageng-roast-05&orientation=landscape",
  },
  {
    id: "r6",
    title: "剧集魔改原著被喷，瓜哥：改可以，改得好看再说",
    summary:
      "改编不是原罪，改得自相矛盾才是。瓜哥把原著高光和剧版改动并排放，聊聊观众到底在气哪一点。",
    category: "影视吐槽",
    author: "瓜哥",
    date: "2026-08-09",
    heat: "29.8万",
    read: "9 分钟",
    tags: ["改编争议", "原著对比"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20open%20books%20floating%20with%20warm%20coral%20and%20amber%20glow%2C%20magical%20library%20atmosphere%2C%20editorial%20conceptual%20still%20life%2C%20dark%20warm%20background%2C%20cinematic%20lighting%2C%20clean%20composition&width=800&height=600&seq=guageng-roast-06&orientation=landscape",
  },
];

export const moments = [
  {
    title: "后台走廊的那次回头",
    desc: "镜头只给了两秒，但表情管理全线崩盘，成了当晚被截最多的一帧。",
    heat: "18.6万",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20backstage%20corridor%20with%20warm%20amber%20wall%20lamps%20and%20dramatic%20shadow%2C%20cinematic%20empty%20hallway%2C%20no%20people%2C%20moody%20editorial%20photography%2C%20warm%20coral%20tones%2C%20high%20contrast&width=900&height=1100&seq=guageng-moment-01&orientation=portrait",
  },
  {
    title: "颁奖台上的三秒沉默",
    desc: "念到名字的那一刻，全场安静了三秒，这三秒比获奖感言更耐人寻味。",
    heat: "23.4万",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20empty%20awards%20podium%20with%20warm%20gold%20spotlight%20and%20deep%20red%20curtain%2C%20cinematic%20stage%20atmosphere%2C%20no%20people%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20dramatic%20lighting&width=900&height=1100&seq=guageng-moment-02&orientation=portrait",
  },
  {
    title: "直播间的突然静音",
    desc: "上一秒还在热聊，下一秒声音全没了，弹幕瞬间刷满问号，成了当天的快乐源泉。",
    heat: "15.2万",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20broadcast%20microphone%20and%20studio%20headphones%20on%20warm%20wooden%20table%2C%20on%20air%20sign%20glow%2C%20editorial%20still%20life%2C%20warm%20amber%20and%20coral%20lighting%2C%20dark%20clean%20background&width=900&height=1100&seq=guageng-moment-03&orientation=portrait",
  },
  {
    title: "发布会上的那句反问",
    desc: "记者问得含糊，回答更含糊，一句反问把整场发布会的气氛推到了顶点。",
    heat: "27.1万",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20press%20conference%20microphone%20row%20with%20warm%20lighting%20and%20blurred%20backdrop%2C%20editorial%20media%20photography%2C%20no%20people%2C%20warm%20amber%20tones%2C%20cinematic%20composition&width=900&height=1100&seq=guageng-moment-04&orientation=portrait",
  },
];

export const quotes = [
  { text: "别急着站队，先让子弹飞一会儿，飞回来的可能是回旋镖。", source: "塌房连环瓜复盘", likes: "3.2万" },
  { text: "剧本可以写，但观众的记性比编剧长。", source: "综艺赛制翻车", likes: "2.8万" },
  { text: "塌房不是一瞬间的事，是每一块砖早就松了很久。", source: "热点时间线", likes: "4.1万" },
  { text: "精修图负责好看，生图负责诚实。", source: "红毯生图大战", likes: "1.9万" },
  { text: "热搜第一不代表真相第一，只代表嗓门第一。", source: "舆论场观察", likes: "3.6万" },
  { text: "控评控得住版面，控不住路人的眼睛。", source: "饭圈观察", likes: "2.4万" },
  { text: "瓜要一口一口吃，话要一句一句过脑子。", source: "瓜哥语录", likes: "5.0万" },
  { text: "改可以，改得好看再说。", source: "影视改编吐槽", likes: "2.1万" },
];

export const topics = [
  { name: "综艺观察", desc: "赛制、剪辑、剧本感，逐帧看综艺", count: 386, icon: "ri-live-line" },
  { name: "热点复盘", desc: "按分钟还原事件时间线", count: 512, icon: "ri-history-line" },
  { name: "影视吐槽", desc: "改编、逻辑、演技全维度开麦", count: 274, icon: "ri-film-line" },
  { name: "饭圈观察", desc: "控评、应援、话术拆解", count: 198, icon: "ri-group-line" },
  { name: "星光造型", desc: "红毯生图与造型点评", count: 143, icon: "ri-vip-diamond-line" },
  { name: "名场面", desc: "被截最多的高能瞬间", count: 429, icon: "ri-flashlight-line" },
];

export const featured = {
  title: "一场热搜的完整生命周期：从爆料到反转，我们到底在围观什么",
  meta: "瓜哥 · 2026-08-30 · 长评 · 阅读 11 分钟",
  lead:
    "每一次热搜都像一场临时搭起的戏台：有人上台，有人拆台，更多人只是路过看两眼。这篇长评，瓜哥想把戏台拆开给你看，它到底是怎么搭起来的。",
  image:
    "https://readdy.ai/api/search-image?query=stylized%20theatrical%20stage%20with%20warm%20red%20curtains%20partially%20open%20and%20amber%20spotlight%2C%20empty%20stage%20with%20spotlight%20haze%2C%20cinematic%20editorial%20photography%2C%20warm%20coral%20and%20gold%20palette%2C%20dramatic%20clean%20composition&width=1200&height=800&seq=guageng-feature-01&orientation=landscape",
  paragraphs: [
    {
      h: "热点不是突然发生的",
      p: "一条爆料出现之前，通常已经有过几轮小范围试探：模糊的截图、欲言又止的暗语、突然清空的旧动态。这些碎片单独看都不算什么，凑在一起才成了热搜的第一块积木。瓜哥的习惯是先不评论，只把时间点排好队。",
    },
    {
      h: "围观者比当事人更着急",
      p: "当事人还在斟酌措辞，评论区已经替他把立场定好了。有人着急站队，有人着急替人道歉，还有人只是想让自己的判断显得比别人快一步。热搜的温度，往往不是事件本身给的，而是围观情绪给的。",
    },
    {
      h: "反转是常态，不是意外",
      p: "信息越碎，反转越多。当一条消息只靠截图和转述传递，它就已经埋好了反转的伏笔。所以瓜哥总说，别急着下结论，先看看还有谁没开口。沉默的人，往往才是最关键的变量。",
    },
    {
      h: "看完热闹，记得带走点什么",
      p: "吃瓜本身没有错，热闹也是生活的一部分。但如果围观之后只剩情绪，那这场热闹就白看了。瓜哥希望每一次拆瓜，都能让你多一分判断力：分清事实和猜测，分清表达和攻击，分清热闹和真相。",
    },
  ],
};

export const testimonials = [
  { name: "橘子汽水", tag: "追更两年", text: "别人吃瓜是看戏，瓜哥吃瓜是拆戏。时间线一列出来，我瞬间明白自己昨天在气什么。", initial: "橘", tone: "primary" },
  { name: "半夜刷屏", tag: "弹幕收藏党", text: "金句弹幕那块我能看一晚上，有些话真的就是我想说但组织不出来的语言。", initial: "半", tone: "accent" },
  { name: "不吃香菜", tag: "理性围观", text: "最喜欢瓜哥那句别急着站队。现在热点反转太多，有个人帮你冷静一下真的难得。", initial: "不", tone: "secondary" },
  { name: "晚八点见", tag: "综艺爱好者", text: "赛制那期讲得也太细了，逐帧标注比我回看三遍还清楚，服了。", initial: "晚", tone: "accent" },
  { name: "小满", tag: "路人转粉", text: "吐槽很狠但不刻薄，笑完之后还觉得有道理，这种平衡感挺难的。", initial: "满", tone: "primary" },
  { name: "望山", tag: "长评常客", text: "长评是真的用心在写，不是凑字数。一篇看下来对舆论场的理解都清楚了不少。", initial: "望", tone: "secondary" },
];

export const faqs = [
  {
    q: "瓜哥吃瓜的内容主要看什么？",
    a: "主要看三件事：热点事件的完整时间线、藏在细节里的槽点，以及能让人会心一笑的犀利点评。我们不做无依据的猜测，也会把事实和观点分开讲清楚。",
  },
  {
    q: "金句弹幕是从哪里来的？",
    a: "金句来自瓜哥长期整理的高能弹幕与评论，会结合具体名场面标注出处。每一句都尽量保留当时的语境，避免断章取义。",
  },
  {
    q: "为什么同一个热点会看到好几篇不同角度的内容？",
    a: "因为一个热点可以拆出很多层：时间线、公关话术、网友反应、行业惯例。不同角度讲的是不同的问题，合起来才是一整只瓜。",
  },
  {
    q: "瓜哥的点评会不会带节奏？",
    a: "我们的原则是先摆事实再给观点，并且明确区分两者。如果信息还不完整，我们会直接标注待补充，而不是先替你下判断。",
  },
  {
    q: "怎么第一时间看到新内容？",
    a: "可以在页面底部的订阅区留下邮箱，每周我们会把当周最值得回看的神点评和名场面整理成一封简报发给你，不刷屏、不打扰。",
  },
];